jQuery(document).ready(function ($) {

    var pathname = (window.location.pathname).split('/');
    var derivedClass = pathname[1] + "-ref";

    $('body').addClass(derivedClass);

    $('footer .navigation-block ul').outerHeight();

    $('.acc-content').each(function () {
        $(this).find('table').wrapAll('<div class="table-container"></div>');
    })

    var navType = performance.navigation.type;
    var userAgent = navigator.userAgent;

    sessionStorage.setItem('navType', navType);

    setTimeout(function () {

        var savedType = sessionStorage.getItem('navType');

        if (userAgent.indexOf("Firefox") != -1) {
            if (savedType === "1") {
                console.log('Firefox initiated')
                $('html').scrollTop('0');
            }
        }

        if (userAgent.indexOf("Chrome") != -1) {
            if (savedType === "2") {
                console.log('Chrome initiated')
                $('html').scrollTop('0');
            }
        }

    }, 300)



    // var OSName = "Unknown OS";
    if (navigator.userAgent.indexOf("Win") != -1) {
        $('.radiobox').addClass('win-adjust');

        if (window.location.host.indexOf('staging') != -1) {
            $('.radiobox').addClass('waf-adjust');
        }
    }


    // HEADER SCROLL FEATURE

    var c, currentScrollTop = 0;
    var navbar = $('header');
    var navbarm = $('.mobile-header');
    var page = $('body');

    var prevScrollpos = window.pageYOffset;

    function scrollFeatures() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos < currentScrollPos) {
            if (isMobile()) {
                $('.header-bottom .branch-selection').slideUp();
                $('.header-bottom .container > nav').css({
                    left: ''
                })
            }
            else {
                navbar.addClass("scrollUp");
                $('[id="sub-menu"]').each(function () {
                    $(this).addClass('align-left');
                }); 
                navPos();
                $('.header-bottom .selection-box').slideUp();
                $('.header-bottom .branch-selection .selected a').removeClass('active');
                // menuPlacement();
            }
        } else {
            if (isMobile()) {
                return false;
            }
            else {
                navbar.removeClass("scrollUp");
                $('[id="sub-menu"]').each(function () {
                    $(this).removeClass('align-left');
                });
                $('.header-bottom .container > nav').css({
                    left: ''
                })
                $('.submenu-wrap').css({
                    left: ''
                })
                // menuPlacement();
            }
        }
        prevScrollpos = currentScrollPos;
    }



    function disableScroll() {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            window.onscroll = function () { };
    }

    function enableScroll() {
        window.onscroll = function () {
            scrollFeatures();
        };
    }

    enableScroll();



    function formPlacement() {
        if ($('.keep-updated-block').length > 0) {
            var countY = $('.keep-updated-block').outerHeight();
            var mid = countY / 2;
            $('footer').css({
                'margin-top': '-' + mid + 'px',
                'padding-top': mid + 60
            });
        }

        if ($('.register-form-block').length > 0) {
            if (!isMobile()) {
                var countY = $('.register-form-block .container').outerHeight();
                var faqHeight = $('.register-form-block .container .contact-faqs') ? $('.register-form-block .container .contact-faqs').outerHeight() : 0;

                var mid = countY / 2;
                var repo = mid + 60;
                var newRepo = faqHeight + 60
                var diff1 = (countY - faqHeight) + 60
                var difference = faqHeight > mid && faqHeight < countY ? diff1 : faqHeight >= countY ? 0 : repo
                console.log('Adjustment numbers', diff1, countY, faqHeight, mid, repo, newRepo, difference)

                if ($(window).width() < 992) {
                    var newRepo = faqHeight + mid
                    var newMid = (mid - faqHeight) + 60
                    console.log('newMid', newMid)

                    if (faqHeight > 0 && newRepo > repo) {

                        $('.register-form-block').css({
                            height: newMid
                        });

                        $('.register-form-block .container').css({
                            top: '-' + newRepo + 'px'
                        });

                        $('.register-form-block').prev().css({
                            'margin-bottom': newRepo
                        });

                        $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': newRepo
                        });

                        $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': newRepo
                        });
                    }
                    else {
                        $('.register-form-block').css({
                            height: repo
                        });

                        $('.register-form-block .container').css({
                            top: '-' + mid + 'px'
                        });

                        $('.register-form-block').prev().css({
                            'margin-bottom': repo
                        });

                        $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': repo
                        });

                        $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': repo
                        });
                    }
                }
                else {
                    if (faqHeight > 0 && newRepo > repo) {

                        $('.register-form-block').css({
                            height: difference
                        });

                        $('.register-form-block .container').css({
                            top: '-' + faqHeight + 'px'
                        });

                        $('.register-form-block').prev().css({
                            'margin-bottom': newRepo
                        });

                        $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': newRepo
                        });

                        $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': newRepo
                        });
                    }
                    else {
                        $('.register-form-block').css({
                            height: repo
                        });

                        $('.register-form-block .container').css({
                            top: '-' + mid + 'px'
                        });

                        $('.register-form-block').prev().css({
                            'margin-bottom': repo
                        });

                        $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': repo
                        });

                        $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                            'margin-bottom': repo
                        });
                    }
                }



                var tabY = $('.tabs-wrap .tab.active').outerHeight();
                $('.tabs-wrap').height(tabY);
            }
            else {
                $('.register-form-block').css({
                    height: ''
                });

                $('.register-form-block .container').css({
                    top: ''
                });

                $('.register-form-block').prev().css({
                    'margin-bottom': ''
                });

                $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                    'margin-bottom': ''
                });

                $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                    'margin-bottom': ''
                });

                var tabY = $('.tabs-wrap .tab.active').outerHeight();
                $('.tabs-wrap').height(tabY);
            }
        }
    }

    formPlacement();

    function homePromo() {
        var promoH = $('.banner + .fr-view + .popular-products + script + .promotion-block .container').height();
        var promoMid = promoH / 2;
        var promoRepo = promoMid + 31;
        $('.banner + .fr-view + .popular-products + script + .promotion-block').css({
            'margin-top': '-' + promoRepo + 'px'
        })
        $('.banner + .fr-view + .popular-products').css({
            'padding-bottom': promoRepo + 'px'
        })
    }

    homePromo();


    $('.keep-updated-block form').submit(function () {
        setTimeout(function () {
            formPlacement();
        }, 500)
    });


    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $('body').addClass('mac');
    }
    else {
        $('body').addClass('windows');
    }


    // setTimeout(function(){
    //     menuPlacement();
    // }, 500)

    function menuPlacement() {
        var leftOffset = $('.header-bottom .container>nav').offset().left
        console.log('leftOffset1',  leftOffset);
        if (isMobile()) {
            $('.parentlink > a').each(function () {
                var $this = $(this);
                $this.next('.dropdown-menu').css('left', '');
            });
        }
        else {
            $('.parentlink > a').each(function () {
                var $this = $(this);
                console.log('leftoffset2', $this.offset().left)
                var offsetY = ($this.offset().left - leftOffset) - 16;
                $this.next('.dropdown-menu').css('left', offsetY);
            });
        }
    }



    // MOBILE MENU CONVERSION

    function isMobile() {
        return $(window).width() < 768;
    }

    var navState = false;
    var menuState = true;
    var cat;

    function menuInteractions() {
        if (isMobile()) {
            //$('.sub-navigation h3 a.arrowStyle').click(function (e) {
            //    e.preventDefault();
            //})
            if ($('.header-top .user-controls .burger-wrap').length < 1) {
                $('.header-top .user-controls').append('<div class="burger-wrap"><span class="burger-menu"></span></div>');
            }
            if (!navState) {
                $('.header-bottom .container > nav').hide();
            }
            if ($('.submenu-wrapper .back-menu').length < 1) {
                $('.submenu-wrapper').prepend('<a href="#" class="back-menu">Main Menu</a>');
            }

            if ($('.header-bottom .dropdown-menu .back-menu').length < 1) {
                $('.header-bottom .dropdown-menu').prepend('<a href="#" class="back-menu">Main Menu</a>');
            }

            $('.header-bottom .container nav ul li.parentlink').each(function () {
                var $this = $(this)
                var navText = $this.find('a').eq(0).text();
                //console.log(navText)
                $this.find('.sub-navigation').each(function () {
                    var @this = $(this)
                    if (@this.find('.submenu .back-menu').length < 1) {
                        //@this.find('.submenu').prepend('<a href="#" class="back-menu">' + navText + '</a>');
                    }

                    if (@this.find('.submenu .viewall-menu').length < 1) {
                        //$('.sub-navigation').each(function () {
                        var catText = $(this).find('h3 a').text();
                        var link = $(this).find('h3 a').attr('href')
                        @this.find('.submenu').prepend('<a href="' + link + '" class="viewall-menu">View all ' + catText + '</a>');
                        @this.find('.submenu').prepend('<a href="#" class="back-menu">' + navText + '</a>');
                        //console.log($(this).find('.submenu').length, catText)
                        if (@this.find('.submenu').length > 0) {
                            @this.find('h3 a').addClass('arrowStyle');
                        }

                        //})
                    }
                })
            })

            
            $('.burger-wrap').off();
            $('.burger-wrap').click(function () {
                if (navState) {
                    navState = false;
                }
                else {
                    navState = true;
                }
                $('.header-bottom .branch-selection').slideUp();
                $('.user').next().slideUp();
                //$(this).toggleClass('is-open');
                if ($(this).find(".burger-menu").hasClass('is-open')) {
                    $(this).find(".burger-menu").removeClass('is-open');
                    $('.header-bottom .container > nav').slideUp();
                    setTimeout(function () {
                        $('.header-bottom .container > nav > ul').css('left', '0');
                        $('.header-bottom .container > nav .submenu-wrap, .header-bottom .container > nav .sub-navigation nav').css('left', '100%');
                    }, 400)
                    enableScroll();
                }
                else {
                    $(this).find(".burger-menu").addClass('is-open');
                    $('.header-bottom .container > nav').slideDown();
                    disableScroll();
                }


                if ($('header').hasClass('header-open')) {
                    $('header').removeClass('header-open');
                } else {
                    $('header').addClass('header-open');
                }

                if ($('.mega-menu').hasClass('show')) {
                    $('.mega-menu').removeClass('show');
                }
            })

            $('.header-bottom .container nav ul li a').click(function (e) {
                if ($(this).parent().hasClass('parentlink')) {
                    e.preventDefault();
                    $(this).next().animate({
                        left: '0'
                    }, 300)
                    $(this).parents('ul').animate({
                        left: '-100%'
                    }, 300)
                }
                else {
                    if ($(this).hasClass('arrowStyle')) {
                        e.preventDefault();
                        //console.log($(this).text())
                        $(this).parent().next().animate({
                            left: '0'
                        }, 300)
                        $(this).parents('.submenu-wrap').animate({
                            left: '-100%'
                        }, 300)
                    }
                }
                
                    
                    //else if ($(this).parent().parent().hasClass('sub-navigation')) {
                    //    e.preventDefault();
                    //    $(this).parent().next().animate({
                    //        left: '0'
                    //    }, 300);
                    //    $(this).parents('.sub-navigation').parents('.submenu-wrap').animate({
                    //        left: '-100%'
                    //    }, 300)
                    //}

            })

            $('.back-menu').click(function (e) {
                e.preventDefault();
                if ($(this).parent().hasClass('submenu')) {
                    $(this).parent().parent().animate({
                        left: '100%'
                    }, 300)
                    $(this).parents('.submenu-wrap').animate({
                        left: '0'
                    }, 300);
                }
                else {
                    $(this).parents('.submenu-wrap').animate({
                        left: '100%'
                    }, 300);
                    $(this).parent('.dropdown-menu').animate({
                        left: '100%'
                    }, 300)
                    $(this).parents('.dropdown-menu, .submenu-wrap').parents('ul').animate({
                        left: '0'
                    }, 300);
                }
            })
        }
        else {
            navState = false;
            $('.header-top .user-controls .burger-wrap').remove();
            $('.header-bottom .container > nav, .header-bottom .branch-selection').css('display', '');
            $('.submenu-wrap').css('left', '');
            // $('.submenu-wrap').show();
            $('.submenu-wrapper .back-menu').remove();
            $('.header-bottom .dropdown-menu .back-menu').remove();
            $('.sub-navigation').each(function () {
                $(this).find('.viewall-menu').remove()
                $(this).find('.back-menu').remove();
            })
            $('.parentlink > a').off();
            $('.parentlink > a').on('click', function (e) {
                e.preventDefault();
                var $this = $(this);

                if ($this.hasClass('active')) {
                    $this.removeClass('active')
                    $this.next().slideUp(350);
                    enableScroll();
                }
                else {
                    $('.parentlink > a').removeClass('active');
                    $('.submenu-wrap, .dropdown-menu').slideUp(350);
                    $this.addClass('active');
                    $this.next().slideDown(350);
                    disableScroll();
                }

                if ($('.submenu-wrap .submenu-navs').length > 0) {

                    if (menuState) {
                        setTimeout(function () {
                            $('.submenu-wrap .submenu-navs').masonry('destroy');
                            $('.submenu-wrap .submenu-navs').masonry({
                                itemSelector: '.sub-navigation',
                                percentPosition: true,
                                columnWidth: 1,
                            });
                        }, 100)
                    }
                    else {
                        setTimeout(function () {
                            $('.submenu-wrap .submenu-navs').masonry({
                                itemSelector: '.sub-navigation',
                                percentPosition: true,
                                columnWidth: 1,
                            });
                        }, 10)
                        menuState = true;
                    }

                    $('.sub-navigation a').on('click', function (e) {
                        setTimeout(function () {
                            $('.submenu-wrap').slideUp(350);
                            $('.submenu-wrap .submenu-navs').masonry('destroy')
                        }, 100)
                    })
                }
                console.log(menuState);

            });
        }
    }

    menuInteractions();


    $('.search-trigger').click(function (e) {
        e.preventDefault();
        $('header').removeClass('scrollUp');
        $('.header-top .middle input[type="search"]').focus();
    });


    $('.location-trigger').click(function (e) {
        e.preventDefault();
        if (isMobile()) {
            $('header').removeClass('scrollUp');
            $('.user').next().slideUp();
            $('.header-bottom .branch-selection').slideToggle();
            $(".burger-wrap .burger-menu").removeClass('is-open');
            $('.header-bottom .container > nav').slideUp();
        }
        else {
            $('header').removeClass('scrollUp');
            $('.header-bottom .selection-box').slideDown();
            $('.header-bottom .branch-selection .selected a').addClass('active')
        }

    })

    $('.user').on('click', function (e) {
        e.preventDefault();
        $(this).next().slideToggle();
        if (isMobile()) {
            $('.header-bottom .branch-selection').slideUp();
            $(".burger-wrap .burger-menu").removeClass('is-open');
            $('.header-bottom .container > nav').slideUp();
        }
        menuState = false;
        console.log(menuState);
    });

    console.log(menuState);

    $(document).on('click','.header-bottom .branch-selection .selected a', function (e) {
        e.preventDefault();
        if (isMobile()) {
            return false;
        }
        else {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
                $('.header-bottom .selection-box').slideUp(350);
                enableScroll();
            }
            else {
                $(this).addClass('active');
                $('.header-bottom .selection-box').slideDown(350);
                disableScroll()
            }
        }
    });

    $('.header-top .middle input[type=search]').hover(function () {
        enableScroll();
        $('.header-bottom .branch-selection .selected a').removeClass('active');
        $('.header-bottom .selection-box').slideUp(350);
    })

    $('.selection-box .close-dialog').on('click', function (e) {
        e.preventDefault();
        $('.availability-checker').animate({
            right: '-100%'
        }, function () {
            $('.availability-overlay').hide();
            enableScroll();
        })

    });


    $('body').on('click', function (e) {
        var t = e.target;

        // If the click is inside the suggestionsList, ignore it
        if (typeof suggestionsList !== 'undefined' && suggestionsList.contains(t)) {
            return; 
        }

        if (!isMobile()) {
            if (!$(t).is('.parentlink > a, .sub-navigation ul li a, .mobile-menu nav li a') && !$(t).parents().is('.submenu-wrap, .mobile-menu, .dropdown-menu')) {
                $('.parentlink > a').removeClass('active');
                $('.submenu-wrap, .header-bottom .dropdown-menu').slideUp();
                // $('.submenu-wrap .submenu-navs').masonry('layout');
            }

            if (!$(t).is('.branch-selection .selected a, .location-trigger, .pac-item, .selection-box .show-more, .overlay') && !$(t).parents().is('.selection-box, .pac-container, .overlay') && !(t.getAttribute('data-item') === 'searchAULocation-item')) {
                $('.branch-selection .selected a').removeClass('active');
                $('.header-bottom .selection-box').slideUp();
            }

            if (!$(t).is('.user') && !$(t).parents().is('.user-controls .dropdown-menu')) {
                $('.user-controls .dropdown-menu').slideUp();
            }

            if (!$(t).is('.add-to-cart, .summary-block .btn, .dialog') && !$(t).parents().is('.dialog')) {
                $('.cart-popup').fadeOut();
            }

            if (!$(t).is('.parentlink > a, .sub-navigation ul li a, .mobile-menu nav li a, .branch-selection .selected a, .location-trigger') && !$(t).parents().is('.submenu-wrap, .mobile-menu, .dropdown-menu, .selection-box')) {
                enableScroll();
            }

            if (!$(t).parents().is('.autocomplete-wrap')) {
                $('.autocomplete-wrap').slideUp();
            }
        }

    });

    setTimeout(function () {
        $('.pac-container, .af_list').on('DOMSubtreeModified', function () {
            $('body').click(function (e) {
                var t = e.target;
                if ($(t).is('.af_list') && $(t).parents().is('.af_list')) {
                    e.stopPropagation();
                    return false;
                }

            })
        })
    }, 5000);




    $('.cancel-btn').click(function (e) {
        e.preventDefault();
        $(this).parents('.overlay').fadeOut();
    })

    $('.close-submenu').on('click', function (e) {
        e.preventDefault();
        $('.parentlink > a').removeClass('active');
        $('.submenu-wrap').slideUp();
    });

    // Banner
    if ($('.banner-slider .slider-item').length > 1) {
        $('.banner-slider').owlCarousel({
            autoplay: true,
            loop: true,
            nav: true,
            dots: true,
            items: 1,
            autoplayHoverPause: true
        });
    }
    else {
        $('.banner-slider').removeClass('owl-carousel').addClass('no-slider');
    }

    // Content Carousel
    if ($('.content-carousel .slide-item').length > 1) {
        $('.content-carousel').owlCarousel({
            autoplay: true,
            loop: true,
            nav: true,
            dots: true,
            items: 1,
            stagePadding: 0,
            autoplayHoverPause: true
        });
    }

    var screenSize = $(window).width();


    // Featured product slider

    function nonProductCarousel() {
        if (screenSize > 1024) {
            $(".non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 4) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 4,
                        items: 4.01,
                        margin: 19,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 660 && screenSize < 1025) {
            $(".non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 3) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 3,
                        items: 3.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 800,
                        navSpeed: 200,
                        fluidSpeed: 800,
                        dotsSpeed: 200,
                        smartSpeed: 800
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 374 && screenSize < 661) {
            $(".non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 2) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 2,
                        items: 2.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 0 && screenSize < 375) {
            $(".non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 1) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 1,
                        items: 1.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }
    }

    nonProductCarousel();


    function productCarousel() {
        if (screenSize > 1024) {
            $(".products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 4) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 4,
                        items: 4.01,
                        margin: 19,
                        slideBy: 4,
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000,
                        onTranslated: tooltipFix
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 660 && screenSize < 1025) {
            $(".products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 3) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 3,
                        items: 3.01,
                        margin: 16,
                        slideBy: 3,
                        slideSpeed: 1000,
                        autoplaySpeed: 800,
                        navSpeed: 200,
                        fluidSpeed: 800,
                        dotsSpeed: 200,
                        smartSpeed: 800,
                        onTranslated: tooltipFix
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 374 && screenSize < 661) {
            $(".products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 2) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 2,
                        items: 2.01,
                        margin: 16,
                        slideBy: 2,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500,
                        onTranslated: tooltipFix
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 0 && screenSize < 375) {
            $(".products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 1) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 1,
                        items: 1.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500,
                        onTranslated: tooltipFix
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }
    }

    productCarousel();


    function winnersCarousel() {
        if (screenSize > 1024) {
            $(".winners-block .products-slider, .winners-block .non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 4) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 4,
                        items: 4.01,
                        margin: 19,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 660 && screenSize < 1025) {
            $(".winners-block .products-slider, .winners-block .non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 3) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 3,
                        items: 3.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 800,
                        navSpeed: 200,
                        fluidSpeed: 800,
                        dotsSpeed: 200,
                        smartSpeed: 800
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 424 && screenSize < 661) {
            $(".winners-block .products-slider, .winners-block .non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 2) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 2,
                        items: 2.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 0 && screenSize < 425) {
            $(".winners-block .products-slider, .winners-block .non-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 1) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 1,
                        items: 1.01,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }
    }

    winnersCarousel();


    function packagesCarousel() {
        if (screenSize > 1024) {
            $(".packages-block .products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 4) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 4,
                        items: 4.01,
                        margin: 19,
                        slideBy: 4,
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 660 && screenSize < 1025) {
            $(".packages-block .products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 3) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 3,
                        items: 3.01,
                        margin: 16,
                        slideBy: 3,
                        slideSpeed: 1000,
                        autoplaySpeed: 800,
                        navSpeed: 200,
                        fluidSpeed: 800,
                        dotsSpeed: 200,
                        smartSpeed: 800
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 424 && screenSize < 661) {
            $(".packages-block .products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 2) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 2,
                        items: 2.01,
                        margin: 16,
                        slideBy: 2,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 0 && screenSize < 425) {
            $(".packages-block .products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 1) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 1,
                        items: 1.5,
                        margin: 16,
                        slideBy: 1,
                        slideSpeed: 1000,
                        autoplaySpeed: 500,
                        navSpeed: 200,
                        fluidSpeed: 500,
                        dotsSpeed: 200,
                        smartSpeed: 500
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }
    }

    packagesCarousel();


    function evProductCarousel() {
        if (screenSize > 1023) {
            $(".ev-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 3) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 3,
                        items: 3.01,
                        margin: 20,
                        slideBy: 3,
                        startPosition: 'right',
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 499 && screenSize < 1024) {
            $(".ev-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 2) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        dotsEach: 2,
                        items: 2.01,
                        margin: 16,
                        slideBy: 2,
                        startPosition: 'right',
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }

        if (screenSize > 0 && screenSize < 500) {
            $(".ev-products-slider").each(function () {
                var itemCount = $(this).find('.product-item').length;
                if (itemCount > 1) {
                    $(this).owlCarousel('destroy');
                    $(this).addClass('owl-carousel').removeClass('no-slider');
                    $(this).owlCarousel({
                        autoplay: false,
                        loop: true,
                        nav: false,
                        dots: true,
                        dotsEach: 1,
                        items: 1.01,
                        margin: 16,
                        slideBy: 1,
                        startPosition: 'right',
                        slideSpeed: 1000,
                        autoplaySpeed: 1000,
                        navSpeed: 200,
                        fluidSpeed: 1000,
                        dotsSpeed: 200,
                        smartSpeed: 1000
                    });
                } else {
                    $(this).removeClass('owl-carousel').addClass('no-slider');
                }
            })
        }
    }

    evProductCarousel();


    function brandsSlider() {
        if (screenSize < 1001 && screenSize > 767) {
            if (!$('.brands-wrap').hasClass('brands-slider')) {
                $('.brands-wrap').addClass('owl-carousel owl-theme').removeClass('flex');
                $('.brands-wrap').owlCarousel('destroy');
                $('.brands-wrap').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 4,
                    items: 4.01,
                    margin: 16,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                })
            }
            else {
                $('.brands-slider').owlCarousel('destroy');
                $('.brands-slider').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 4,
                    items: 4.01,
                    stagePadding: 0,
                    margin: 18,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                });
            }
        }

        if (screenSize < 768 && screenSize > 500) {
            if (!$('.brands-wrap').hasClass('brands-slider')) {
                $('.brands-wrap').addClass('owl-carousel owl-theme').removeClass('flex');
                $('.brands-wrap').owlCarousel('destroy');
                $('.brands-wrap').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 3,
                    items: 3.01,
                    margin: 16,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                })
            }
            else {
                $('.brands-slider').owlCarousel('destroy');
                $('.brands-slider').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 3,
                    items: 3.01,
                    stagePadding: 0,
                    margin: 18,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                });
            }

        }

        if (screenSize < 501) {
            if (!$('.brands-wrap').hasClass('brands-slider')) {
                $('.brands-wrap').addClass('owl-carousel owl-theme').removeClass('flex');
                $('.brands-wrap').owlCarousel('destroy');
                $('.brands-wrap').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 2,
                    items: 2.01,
                    margin: 16,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                })
            }
            else {
                $('.brands-slider').owlCarousel('destroy');
                $('.brands-slider').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    dotsEach: 2,
                    items: 2.01,
                    stagePadding: 0,
                    margin: 18,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                });
            }
        }

        if (screenSize > 1000) {
            if (!$('.brands-wrap').hasClass('brands-slider')) {
                $('.brands-wrap').owlCarousel('destroy');
                $('.brands-wrap').removeClass('owl-carousel owl-theme').addClass('flex');
            }
            else {
                $('.brands-slider').owlCarousel('destroy');
                $('.brands-slider').owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: true,
                    dots: false,
                    items: 5.01,
                    stagePadding: 0,
                    margin: 18,
                    slideSpeed: 4000,
                    autoplaySpeed: 1000,
                    navSpeed: 1000,
                    fluidSpeed: 1000,
                    dotsSpeed: 200,
                    smartSpeed: 1000,
                    autoplayHoverPause: true
                });
            }
        }
    }

    brandsSlider();

    function mediaSlider() {

        if (screenSize < 768 && screenSize > 0) {
            $('.media-list').addClass('owl-carousel owl-theme')
            $('.media-list').owlCarousel('destroy');
            $('.media-list').owlCarousel({
                autoplay: false,
                nav: false,
                dots: true,
                items: 1,
                margin: 0,
                slideSpeed: 4000,
                autoplaySpeed: 1000,
                navSpeed: 1000,
                fluidSpeed: 1000,
                dotsSpeed: 200,
                smartSpeed: 1000,
                autoplayHoverPause: true,
                onTranslated: mediaChange
            })

        }

        if (screenSize > 767) {
            $('.media-list').owlCarousel('destroy');
            $('.media-list').removeClass('owl-carousel owl-theme');
        }
    }

    mediaSlider();


    function mediaChange() {
        // var activeMedia = $('.media-list .owl-item.active').index();
        $('.media-list .owl-item.active').find('.media-item').click();
        // console.log(activeMedia);
    }

    mediaChange();

    // $('.media-item').click(function() {
    //     console.log('working')
    // })


    if ($('.story-carousel').length > 0) {



        $('.story-carousel').each(function () {

            if ($(this).find('.slide-item').length > 1) {
                var sync1 = $(this);
                var sync2 = $(this).next();
                var slidesPerPage = 1; //globaly define number of elements per page
                var syncedSecondary = true;

                sync1.owlCarousel({
                    autoplay: true,
                    loop: true,
                    nav: true,
                    dots: true,
                    items: 1,
                    autoplayHoverPause: true,
                    onInitialized: dotsAlign,
                    onRefreshed: dotsAlign,
                    onTranslated: syncPosition
                });

                sync2
                    .owlCarousel({
                        items: slidesPerPage,
                        dots: false,
                        nav: false,
                        loop: true,
                        touchDrag: false,
                        mouseDrag: false,
                        slideBy: slidesPerPage //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                    })

                function syncPosition(el) {
                    //if you set loop to false, you have to restore this next line
                    var current = el.item.index;
                    var count = el.item.count - 1;
                    var current = Math.round(el.item.index - (el.item.count / 2) - .5);

                    if (current < 0) {
                        current = count;
                    }
                    if (current > count) {
                        current = 0;
                    }

                    // //end block

                    sync2
                        .find(".owl-item")
                        .removeClass("current")
                        .eq(current)
                        .addClass("current");
                    var onscreen = sync2.find('.owl-item.active').length - 1;
                    var start = sync2.find('.owl-item.active').first().index();
                    var end = sync2.find('.owl-item.active').last().index();

                    if (current > end) {
                        sync2.data('owl.carousel').to(current, 100, true);
                    }
                    if (current < start) {
                        sync2.data('owl.carousel').to(current - onscreen, 100, true);
                    }
                }

                $(".story-carousel .owl-nav button.owl-next").click(function () {
                    sync2.trigger('next.owl.carousel');
                })

                $(".story-carousel .owl-nav button.owl-prev").click(function () {
                    sync2.trigger('prev.owl.carousel');
                });

            }
            else {
                $(this).removeClass('owl-carousel').addClass('no-slider');
            }

        });
    };

    function dotsAlign() {
        $('.story-carousel').each(function () {
            var storyRadius = $(this).outerWidth() / 2;
            var storyDotsRadius = $(this).find('.owl-dots').outerWidth() / 2;
            var storyCenter = storyRadius - storyDotsRadius;
            $(this).find('.owl-dots').css('left', storyCenter);
        });
    }

    $('.thumbnail').click(function (e) {
        e.preventDefault();
        var target;
        var ind = $(this).parents('.owl-item').index();
        $(this).parents(".story-carousel").trigger('stop.owl.autoplay')
        $(this).parents(".story-carousel").next().addClass('popup');
        if ($(this).parents(".story-carousel").hasClass('no-slider')) {
            target = $(this).parents(".story-carousel").next().find('.slide-item .media-popup')
        }
        else {
            target = $(this).parents(".story-carousel").next().find('.owl-stage .owl-item').eq(ind).find('.media-popup');
        }
        var videoData = target.data('video');
        console.log(videoData);
        if (target.find('.media-container').html() === '') {
            target.find('.media-container').append(videoData);
        }
        else {
            return null;
        }
        setTimeout(function () {
            target.find('#middys-overlay').remove();
        }, 800)
    });

    $('.close-media').click(function (e) {
        e.preventDefault();
        var src = $(this).next().attr('src');
        $(this).next().attr('src', '');
        $(this).next().attr('src', src);
        // $('.slide-item video').get(0).pause();
        $(this).parents('.story-carousel2').removeClass('popup');
        $(this).parents('.story-carousel2').prev().trigger('play.owl.autoplay')
        return false;
    });

    $(document).on('keydown', function (event) {
        if (event.key == "Escape") {
            if ($('.story-carousel2').hasClass('popup')) {
                $('.close-media').click();
            }
        }
    });

    if ($('.product-item').length > 0) {
        $('.product-item .cart-wrap').prev().addClass('foot-space');
    }

    // store the slider in a local variable
    var $window = $(window),
        flexslider = { vars: {} };

    // tiny helper function to add breakpoints
    function getGridSize() {
        (window.innerWidth < 577) ? 2 :
            (window.innerWidth < 992) ? 3 : 4;
    }

    // $(function() {
    //   SyntaxHighlighter.all();
    // });


    if ($('#carousel .slides li').length > 1) {
        $('#carousel').flexslider({
            animation: "slide",
            controlNav: false,
            slideshow: false,
            directionNav: true,
            itemWidth: 134,
            minItems: getGridSize(), // use function to pull in initial value
            maxItems: getGridSize(), // use function to pull in initial value
            move: 4,
            itemMargin: 16,
            touch: true,
            pauseOnHover: true,
            asNavFor: '#slider'

        });

        $('#slider').flexslider({
            animation: "slide",
            controlNav: true,
            slideshow: true,
            directionNav: false,
            touch: true,
            pauseOnHover: true,
            start: arrowEvents,
            before: activeSlide,
            after: arrowEvents,
            sync: "#carousel"
        });
    } else {
        $('#carousel, #slider').removeClass('flexslider').addClass('no-slider');
    }

    var windowSize = $(window).width();

    $window.resize(function () {
        var gridSize = getGridSize();

        flexslider.vars.minItems = gridSize;
        flexslider.vars.maxItems = gridSize;
    });

    function activeSlide() {
        var bigID = $('#slider .slides li.flex-active-slide:not(".clone")').next().index() - 1;
        var len = $('#carousel .slides li').length;
        if (bigID === len) {
            bigID = 0;
        }
        $('#carousel .slides li').removeClass('flex-active-slide');
        $('#carousel .slides li').eq(bigID).addClass('flex-active-slide');


        if (windowSize > 0 && windowSize < 577) {
            if (bigID < 2) {
                $('#carousel .slides').css('transform', 'translate3d(0px, 0px, 0px)');
            }
        }
        else if (windowSize > 576 && windowSize < 992) {
            if (bigID < 3) {
                $('#carousel .slides').css('transform', 'translate3d(0px, 0px, 0px)');
            }
        }
        else {
            if (bigID < 4) {
                $('#carousel .slides').css('transform', 'translate3d(0px, 0px, 0px)');
            }
        }

    };

    function arrowEvents() {
        var id = $('#carousel .slides li.flex-active-slide').index();
        if (windowSize > 0 && windowSize < 577) {
            if (id < 2) {
                if ($('#carousel .slides').css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
                    $('#carousel .flex-prev').css('display', 'none');
                }
                else {
                    $('#carousel .flex-prev').css('display', '');
                }
            }
            else {
                $('#carousel .flex-prev').css('display', '');
            }
        }
        else if (windowSize > 576 && windowSize < 992) {
            if (id < 3) {
                if ($('#carousel .slides').css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
                    $('#carousel .flex-prev').css('display', 'none');
                }
                else {
                    $('#carousel .flex-prev').css('display', '');
                }
            }
            else {
                $('#carousel .flex-prev').css('display', '');
            }
        }
        else {
            if (id < 4) {
                if ($('#carousel .slides').css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
                    $('#carousel .flex-prev').css('display', 'none');
                }
                else {
                    $('#carousel .flex-prev').css('display', '');
                }
            }
            else {
                $('#carousel .flex-prev').css('display', '');
            }
        }

    };

    $('#carousel .slides li').click(function () {
        var id = $('#carousel .slides li.flex-active-slide').index();
        if (windowSize > 0 && windowSize < 577) {
            if (id < 2) {
                $('#carousel .flex-prev').css('display', 'none');
            }
            else {
                $('#carousel .flex-prev').css('display', '')
            }
        }
        else if (windowSize > 576 && windowSize < 992) {
            if (id < 3) {
                $('#carousel .flex-prev').css('display', 'none');
            }
            else {
                $('#carousel .flex-prev').css('display', '')
            }
        }
        else {
            if (id < 4) {
                $('#carousel .flex-prev').css('display', 'none');
            }
            else {
                $('#carousel .flex-prev').css('display', '')
            }
        }

    })

    $('#carousel .flex-next').click(function () {
        setTimeout(function () {
            if ($('#carousel .slides').css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
                $('#carousel .flex-prev').css('display', 'none');
            }
            else {
                $('#carousel .flex-prev').css('display', '');
            }
        }, 610);
    })

    $('#carousel .flex-prev').click(function () {
        setTimeout(function () {
            if ($('#carousel .slides').css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
                $('#carousel .flex-prev').css('display', 'none');
            }
            else {
                $('#carousel .flex-prev').css('display', '');
            }
        }, 610);
    })



    function navPos() {
        var ww = $(window).width();
        var space = (ww - 1200) / 2;
        var navSpace = $('.header-bottom .container > nav').outerWidth();
        var newSpace = (ww - navSpace) / 2;
        if (!isMobile()) {
            $('.header-bottom .container > nav').css({
                left: newSpace
            })
            //$('.submenu-wrap').css({
            //    left: "-" + newSpace + "px"
            //})
        }
    }



    function relocateNav() {
        var windowX = $(window).width() / 2;
        var navX = $('.scrollUp .header-bottom .container>nav').outerWidth() / 2;
        var placeX = windowX - navX;
        $('.scrollUp .header-bottom .container>nav').css('left', placeX)
    }

    function revertNav() {
        $('.scrollUp .header-bottom .container>nav').css('left', '')
    }

    $('.delete').click(function (e) {
        e.preventDefault();
        $('.delete-popup').fadeIn();
    })

    $('.login').click(function (e) {
        e.preventDefault();
        $('.login-popup').fadeIn();
    })

    $('.login-dialog .forgot').click(function (e) {
        e.preventDefault();
        $(this).parents('.dialog').hide();
        $('.reset-screen').show();
    })

    $('.back-link').click(function (e) {
        e.preventDefault();
        $(this).parents('.dialog').hide();
        $(this).parents('.dialog').prev().show();
    })

    $('.close-dialog').click(function (e) {
        e.preventDefault();
        $('.login-popup').fadeOut();
        $(this).parents('.overlay').fadeOut();
    })


    // Accordion 
    $('.acc-title').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).next().slideUp();
        } else {
            $(this).addClass('active');
            $(this).next().slideDown();
        }
    });

    function footerLinks() {
        $('.footer-row h3').off();
        if (screenSize < 768) {
            $('.footer-row h3').removeClass('open');
            $('.navigation-block').hide();
            $('.footer-row h3').on('click', function () {
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    $(this).next().slideUp();
                } else {
                    $(this).addClass('open');
                    $(this).next().slideDown();
                }
            });
        }
        else {
            $('.navigation-block').show();
        }
    }

    footerLinks();



    // Tabs 
    $('.tab-links li a').on('click', function (e) {
        e.preventDefault();
        $('.tab-links li a').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('data-id');
        $(".tabs-content-wrap .tab").removeClass('active');
        $(".tabs-content-wrap .tab[data-id=" + id + "]").addClass('active');
    });

    // Tabs 
    $('.product-tabs a').on('click', function (e) {
        e.preventDefault();
        $('.product-tabs a').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('data-id');
        $(".tab-content .tab").removeClass('active');
        $(".tab-content .tab[data-id=" + id + "]").addClass('active');
    });

    $('.custom-select, .field-wrap select').select2({
        minimumResultsForSearch: Infinity,
        width: 'style',
    });

    $('select option').each(function () {
        if ($(this).text() == '') {
            $(this).remove();
        }
    })




    $(document).on('click', '.filter-link', function () {
        if ($(this).parent().hasClass('open-filter')) {
            $(this).parent().removeClass('open-filter');
            $(this).next().slideUp();
        } else {
            // $('.filter-link').next().slideUp();
            // $('.filter-link').parent().removeClass('open-filter');
            $(this).parent().addClass('open-filter');
            $(this).next().slideDown();
        }
    });

    $(window).scroll(function () {
        var sticky = $('.back-to-top'),
            scroll = $(window).scrollTop();

        if (scroll >= 200) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });

    $('.back-to-top').click(function (e) {
        e.preventDefault();
        var st = $('html').offset().top;
        $(window).scrollTop(st);
    })


    if ($('.tabs-wrap .tab').length > 0) {
        setTimeout(function () {
            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
            console.log(tabY);
            formPlacement();
        }, 500);
    }


    function getTabHeight() {

        var tabActive = $('.tabs-wrap .tab.active').outerHeight();
        if (isMobile()) {
            $('.tabs-wrap').animate({
                height: tabActive + 70
            })
        }
        else {
            $('.tabs-wrap').animate({
                height: tabActive
            })
        }
        setTimeout(formPlacement, 500)
    }



    // CHANGING TBAS ON BUTTON CLICK

    function headingCheck() {
        if ($('.tabs-wrap .tab.success-screen').hasClass('active')) {
            $('.trade-registration-block .container > h2').hide();
        }
        else {
            $('.trade-registration-block .container > h2').show();
        }
    }

    $('.summary-block .btn').click(function (e) {
        if ($(this).hasClass('next-step') || $(this).hasClass('prev-step')) {
            cartHeading();
        }
    })

    function cartHeading() {
        setTimeout(function () {
            if ($('.tabs-nav .tab.active').data('id') == "0") {
                $('.heading-block h1').text("Shopping Cart");
                $('.summary-block .next-step').text("Next");
                $('.summary-block .border-btn:not(.prev-step)').show();
                $('.summary-block .prev-step').hide();
            }
            else if ($('.tabs-nav .tab.active').data('id') == "2") {
                $('.heading-block h1').text("Review Order");
                $('.summary-block .next-step').text("Submit");
                $('.summary-block .border-btn:not(.prev-step)').hide();
                $('.summary-block .prev-step').show();
            }
            else if ($('.tabs-nav .tab.active').data('id') == "1") {
                $('.heading-block h1').text("Delivery");
                $('.summary-block .next-step').text("Next");
                $('.summary-block .border-btn:not(.prev-step)').hide();
                $('.summary-block .prev-step').show();
            }
        }, 200)
    }


    $('.show-toggle').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('on');
    })



    // MANUAL FILE UPLOADER

    function uploader() {
        var l = 0;
        var ot, ol;


        $('.cs-form-block .btn').one('click', function () {
            resetControls();
        });

        // Open file selector on div click
        $("#uploadfile").click(function () {
            if ($(".attached-files label.attached-item").length >= 5) {
                $('.file-progressbar').after('<span class="file-limit-error">Maximum files limit reached.</span>');

            }
            else {
                $('.file-limit-error').fadeOut().remove();
                for (var i = 0; i < $('.file-upload-box .form-field').length; i++) {
                    if ($('.file-upload-box .form-field').eq(i).find('.ktc-file-component-wrapper input').val() === '') {
                        if (!$('.file-upload-box .form-field').eq(i).find('.ktc-file-component-wrapper input').attr('hidden')) {
                            $('.file-upload-box .form-field').eq(i).find('.ktc-file-component-wrapper input').click();
                            return;
                        }
                    }
                }
            }
        });

        $('.ktc-file-component-wrapper .ktc-uploader-text-button').on('DOMSubtreeModified', function () {
            if ($(this).parents('.form-field').hasClass('loaded')) {
                $(this).parents('.form-field').removeClass('loaded').addClass('reset');
                return false;
            }
            else {
                $(this).parents('.form-field').removeClass('reset')
                $(this).parents('.form-field').addClass('loading');
            }
            j = $(this).parents('.file-upload-box').find('.loading').index();
            var $this = $(this);
            var proText = $this.text().split('%').join('');
            if (proText === 'Delete file' && l > 0) {
                var getImage = $this.parent().find('.ktc-uploader-replacement').text();
                $('.file-progressbar').hide();
                $('.progress-state').width('0');
                $('.percent').text(0);
                $('.file-upload-box').show();
                $(this).parents('.form-field').toggleClass('loaded loading');
                if (getImage !== '') {
                    addThumbnail(getImage, j);
                }
                $(this).css({
                    left: ol,
                    top: ot
                })
                $(this).attr('onClick', 'deleteFiles(' + j + ')');
                $(this).parents('.form-field').append(`<script type="text/javascript">
                        function deleteFiles(n) {
                            
                            $('.attached-files label[data-rel="'+n+'"]').remove();
                            if ($(".attached-files label.attached-item").length < 1) {
                                $(".attached-files span").show();
                            }
                            else {
                                $('.attached-files label').each(function(){
                                    var n2 = $(this).data('rel');
                                    var newot = ($(this).offset().top - $('.cs-form-block .container form').offset().top) + 2;
                                    var newol = $(this).offset().left - $('.cs-form-block .container form').offset().left;
                                    if ($('.file-upload-box .form-field').eq(n2).hasClass('loaded')) {
                                        $('.file-upload-box .form-field').eq(n2).find('.ktc-file-component-wrapper .ktc-uploader-text-button').css({
                                            left: newol,
                                            top: newot
                                        })
                                    }
                                })
                            }
                        }
                    </script>
                    `);
                $(this).parents('.form-field').removeClass('reset').addClass('loaded');
                l = 0;
            }
            else {
                $('.file-upload-box').hide();
                $('.file-progressbar').css('display', 'flex');
                $('.progress-state').width(proText + '%');
                $('.percent').text(proText);
                l++;
            }

        });

        function addThumbnail(data, ind) {
            $(".attached-files span").hide();
            var len = $(".attached-files label.attached-item").length;

            var num = Number(len);
            num = num + 1;

            // Creating an thumbnail
            $(".attached-files").append('<label id="attached-item' + num + '" class="flex-align-center attached-item" data-rel="' + ind + '">' + data + '</label>');
            ot = ($('.attached-files label[data-rel="' + ind + '"]').offset().top - $('.cs-form-block .container form').offset().top) + 2;
            ol = $('.attached-files label[data-rel="' + ind + '"]').offset().left - $('.cs-form-block .container form').offset().left;
        }

        function getFiles() {
            var uploaders = $('.file-upload-box .form-field').length;
            for (var r = 0; r < uploaders; r++) {
                var f = $('.file-upload-box .form-field').eq(r).find('.ktc-file-component-wrapper .ktc-uploader-replacement').text();
                if (f != '') {
                    addThumbnail(f, r);
                    $('.file-upload-box .form-field').eq(r).find('.ktc-file-component-wrapper .ktc-uploader-text-button').css({
                        left: ol,
                        top: ot
                    })

                    $('.file-upload-box .form-field').eq(r).find('.ktc-file-component-wrapper .ktc-uploader-text-button').click(function () {
                        var t = $(this).parents('.form-field').index();
                        deleteFiles2(t);
                    })
                    $('.file-upload-box .form-field').eq(r).addClass('loaded')
                }
            }
        }

        function deleteFiles2(n) {

            $('.attached-files label[data-rel="' + n + '"]').remove();
            if ($(".attached-files label.attached-item").length < 1) {
                $(".attached-files span").show();
            }
            else {
                $('.attached-files label').each(function () {
                    var n2 = $(this).data('rel');
                    var newot = ($(this).offset().top - $('.cs-form-block .container form').offset().top) + 2;
                    var newol = $(this).offset().left - $('.cs-form-block .container form').offset().left;
                    if ($('.file-upload-box .form-field').eq(n2).hasClass('loaded')) {
                        $('.file-upload-box .form-field').eq(n2).find('.ktc-file-component-wrapper .ktc-uploader-text-button').css({
                            left: newol,
                            top: newot
                        })
                    }
                })
            }
        }


        getFiles();
        sequenceFix();


    }

    // UPLOADER END

    uploader();


    function sequenceFix() {
        $('.cs-form-block .field-wrap').each(function () {
            if ($(this).find('textarea').length > 0) {
                $(this).addClass('sequence');
            }
        });
    }

    function resetControls() {
        setTimeout(function () {
            $('.cs-form-block .btn').prop('disabled', true);
        }, 100);
        setTimeout(function () {
            uploader();
            $('.cs-form-block .btn').prop('disabled', false);
        }, 1500);
    }



    $('.error-block .close').click(function (e) {
        e.preventDefault();
        $(this).parent().fadeOut();
    })


    $('.state-select-part a').click(function (e) {
        e.preventDefault();
        $('.state-select-part a').removeClass('active');
        $(this).addClass('active');
    })


    $('.three-field-wrap .remove').click(function (e) {
        e.preventDefault();
    })


    // $('label[for*="dietR"]').click(function() {
    //     $(this).parent().next().slideToggle(getTabHeight);
    // })

    $('.media-item').click(function () {
        $(this).parents('.media-list').find('.media-item').removeClass('active');
        $(this).parent().addClass('active');
    })


    $('.tabs-nav .tab').click(function (e) {
        e.preventDefault();
        var th = $(this);
        var thPos = th.index();
        var clickID = th.data('id');
        var tabs = $('.tabs-nav .tab').length;

        if (th.hasClass('complete')) {
            $('.tabs-nav .tab').removeClass('active');
            th.addClass('active');

            $('.tabs-nav .tab').each(function () {
                var genI = $(this).index();
                var ID = $(this).data('id');
                $('.tabs-wrap .tab').removeClass('active');
                $('.tabs-wrap .tab[data-id="' + clickID + '"]').addClass('active');
                if (genI > thPos) {
                    $('.tabs-wrap .tab[data-id="' + genI + '"]').animate({
                        left: '100%'
                    });
                }
                else if (genI < thPos) {
                    $('.tabs-wrap .tab[data-id="' + genI + '"]').animate({
                        left: '-100%'
                    });
                }
                else {
                    $('.tabs-wrap .tab[data-id="' + clickID + '"]').animate({
                        left: '0'
                    });
                }

                getTabHeight();
                tabControl();
                cartHeading();
            })
        }
        else if (th.prev().hasClass('complete')) {
            $('.tabs-nav .tab').removeClass('active');
            th.addClass('active');

            $('.tabs-nav .tab').each(function () {
                var genI = $(this).index();
                var ID = $(this).data('id');
                $('.tabs-wrap .tab').removeClass('active');
                $('.tabs-wrap .tab[data-id="' + clickID + '"]').addClass('active');
                if (genI > thPos) {
                    $('.tabs-wrap .tab[data-id="' + genI + '"]').animate({
                        left: '100%'
                    });
                }
                else if (genI < thPos) {
                    $('.tabs-wrap .tab[data-id="' + genI + '"]').animate({
                        left: '-100%'
                    });
                }
                else {
                    $('.tabs-wrap .tab[data-id="' + clickID + '"]').animate({
                        left: '0'
                    });
                }

                getTabHeight();
                tabControl();
                cartHeading();
            })
        }
    })

    $('form input:not(button):not(#autocomplete-branch), form textarea, form select').on("keydown", function () {
        var keyArray = [];
        var th = $(this).parents('.tab');
        var thPos = th.index();
        var clickID = th.data('id');
        if ($('.tabs-nav .tab.active').data('id') === clickID) {
            $('.tabs-nav .tab[data-id="' + clickID + '"]').removeClass('complete');
        }

        $('.tabs-nav .tab').each(function () {
            var genI = $(this).index();
            if (genI > thPos) {
                $(this).removeClass('complete');
            }
        });
    });


    $('section:not(#scholarship-application) .prev-step').click(function () {
        var st = $('.tabs-wrap .tab').offset().top;
        var tabP = $(this).parents('.tab').prev().height();

        $(this).parents('.tab').animate({
            left: '100%'
        });
        $(this).parents('.tab').prev().animate({
            left: '0'
        });
        $('.tabs-nav').show();
        $('.tabs-nav .tab.active').removeClass('active').prev().addClass('active');
        $(this).parents('.tab').removeClass('active').prev().addClass('active');
        getTabHeight();
        tabControl();
        headingCheck();
        $('html').animate({
            scrollTop: st - 250
        })
    })

    // if ($('.collection-item').length > 0) {
    //     $('.collection-item .note-wrap').prev().addClass('foot-space');
    // }

    $('.collection-item .note-btn').click(function (e) {
        e.preventDefault();
        $('.notes-popup').fadeIn();
    })


    $('.delivery-details .selected-address .note-btn').click(function (e) {
        e.preventDefault();
        $('.address-popup').fadeIn();
    })

    $('.collection-details .selected-address .note-btn').click(function (e) {
        e.preventDefault();
        $('.branch-popup').fadeIn();
    })

    $('.new-add').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).next().show();
        $('.change-address-group').hide();
        $('.add-address-group').show();
    })


    function tabControl() {
        if ($('.tabs-wrap .tab:not(.active) .field-wrap').find('.select2').length > 0) {
            $('.tabs-wrap .tab:not(.active) .field-wrap select').select2('destroy');
        }
        $('.tabs-wrap .tab').find('input, button, select, textarea, a, img').attr('tabindex', '-1');
        $('.tabs-wrap .tab.active').find('input, button, select, textarea, a, img').attr('tabindex', '0');
    }

    tabControl();

    $('.next-step, .prev-step').click(function () {
        tabControl();
        $('.tabs-wrap .tab.active .field-wrap select').select2({
            minimumResultsForSearch: Infinity,
            width: 'style',
        });
    })


    $('.two-columns-block.grey-bg').parent().next().find('.logo-collection-block .container').css('padding', "60px 0 37px")
    $('.event-landing-page .logo-collection-block').eq(1).find('.container').css('padding', "37px 0 60px")

    $('.att-count').parents('.fields-wrapper').addClass('att-info');

    // $('.cart-items-block .tabs-nav .tab').off();
    $('.summary-block .prev-step').addClass('border-btn');


    $('#BtnNewAddress').click(function () {
        $(this).parents('.overlay').animate({
            scrollTop: 0
        })
    })

    $('#btns-group2 .btn.border-btn').click(function () {
        var st = $(this).parents('.dialog').offset().top + 170;
        $(this).parents('.overlay').animate({
            scrollTop: 170
        })
    })

    $('.account-selector-popup .accounts-dropdown ul li').click(function () {
        $('.account-selector-popup .accounts-dropdown ul li').removeClass('active');
        $(this).addClass('active');
    })

    $('.login-btn').click(function () {
        $('#login-login').click(popupFeatures);
    })

    function popupFeatures() {
        setTimeout(function () {
            if ($('.account-selector-popup .accounts-dropdown ul li').length > 4) {
                $('.account-selector-popup .accounts-dropdown').addClass('overflow');
            }
        }, 200)

        if ($('.account-selector-popup .btns-group .btn').length > 1) {
            $('.account-selector-popup .accounts-wrap').css('margin-bottom', '125px');
        }
        else {
            $('.account-selector-popup .accounts-wrap').css('margin-bottom', '70px');
        }

        $('.account-selector-popup .accounts-dropdown ul').on('scroll', function () {
            var sH = $(this)[0].scrollHeight - 15;
            if ($(this).scrollTop() > 10) {
                $('.account-selector-popup .accounts-dropdown').addClass('top-shadow');
            }
            else {
                $('.account-selector-popup .accounts-dropdown').removeClass('top-shadow')
            }

            if ($(this).scrollTop() + $(this).innerHeight() >= sH) {
                $('.account-selector-popup .accounts-dropdown').addClass('bottom-shadow');
            }
            else {
                $('.account-selector-popup .accounts-dropdown').removeClass('bottom-shadow')
            }
        });
    }

    setTimeout(function () {
        if ($('.account-selector-popup .accounts-dropdown ul li').length > 4) {
            $('.account-selector-popup .accounts-dropdown').addClass('overflow');
        }
    }, 200);

    if ($('.account-selector-popup .btns-group .btn').length > 1) {
        $('.account-selector-popup .accounts-wrap').css('margin-bottom', '125px');
    }
    else {
        $('.account-selector-popup .accounts-wrap').css('margin-bottom', '70px');
    }

    $('.account-selector-popup .accounts-dropdown ul').on('scroll', function () {
        var sH = $(this)[0].scrollHeight - 15;
        if ($(this).scrollTop() > 10) {
            $('.account-selector-popup .accounts-dropdown').addClass('top-shadow');
        }
        else {
            $('.account-selector-popup .accounts-dropdown').removeClass('top-shadow')
        }

        if ($(this).scrollTop() + $(this).innerHeight() >= sH) {
            $('.account-selector-popup .accounts-dropdown').addClass('bottom-shadow');
        }
        else {
            $('.account-selector-popup .accounts-dropdown').removeClass('bottom-shadow')
        }
    });


    $('.view-toggle-btns .btn').click(function (e) {
        e.preventDefault();
        $('.view-toggle-btns .btn').removeClass('active');
        $(this).addClass('active');
        if ($(this).hasClass('list-view-toggle')) {
            $('.search-listing-area aside').show();
            $('.search-listing-area #map').hide();
        }
        else {
            $('.search-listing-area aside').hide();
            $('.search-listing-area #map').show();
        }
    })

    function branchStateReposition() {
        if ($('.branch-summary-block:not(.contact-branch-block) .state-select-part').length > 0) {
            var strep = $('.branch-staff-block .location-part').offset().top + $('.branch-staff-block .location-part').outerHeight() + 24;
            if (isMobile()) {
                $('.state-select-part').css('top', strep);
            }
            else {
                $('.state-select-part').css('top', '');
            }
        }
    }

    branchStateReposition();




    function mobileFilters() {
        $('.filter-view-toggle').off()
        $('.filter-view-toggle').click(function (e) {
            e.preventDefault();
            $('.product-filters').animate({
                left: '0'
            }).addClass('view');
        })

        $('.close-filter').off();
        $('.close-filter').click(function (e) {
            e.preventDefault();
            $('.product-filters').animate({
                left: '-100%'
            }).removeClass('view');
        })
        $('.sidebar-toggle').off();
        $('.sidebar-toggle').click(function (e) {
            var translateX = $(this).parents('.account-links').outerWidth();
            e.preventDefault();
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).parents('.account-links').animate({
                    right: '-' + translateX
                })
            }
            else {
                $(this).addClass('open');
                $(this).parents('.account-links').animate({
                    right: '0'
                })
            }
        })

        $('.trade-register .acc-title, .tabs-container .acc-title, .tabs-content-wrap .tab label').off();
        $('.trade-register .acc-title, .tabs-container .acc-title, .tabs-content-wrap .tab label').on('click', function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).next().slideUp();
            } else {
                $(this).addClass('active');
                $(this).next().slideDown();
            }
        });
    }



    var tableData = [];
    $('.accordion-block').each(function () {
        $(this).find('.accordion').each(function () {
            var t = $(this);
            if (t.find('.acc-content .table-container').length > 0) {
                var th = t.find('.table-container').html();
                var ti = t.index()
                tableData.push({ th, ti });
                tableRefactor(ti);
            }
        })
    })

    function tableRefactor(accInd) {
        var grouped = [];
        var vars = [];
        var layout = '';
        $('.accordion-block .accordion').eq(accInd).find('table tr').each(function () {
            var a = $(this);
            a.find('td').each(function () {
                var b = $(this);


                b.find('ul').each(function () {
                    var c = $(this);
                    if (c.prev('strong').length > 0) {
                        // console.log('worked', b.index(), c.prev('strong').text());
                        var d = c.prev('strong').text();
                        var e = c.html().replace("\n", "");
                        vars.push({ d, e });
                    }
                    else {
                        var arrLen = vars.length;
                        var arrVal = vars[arrLen - 1].e;
                        arrVal += c.html().replace("\n", "");
                        vars[arrLen - 1].e = arrVal;
                        // console.log('failed', b.index(), vars);
                    }
                })
            })
        })

        vars.map((item, index) => {
            layout += '<strong>' + item.d + '</strong><ul>'
            layout += item.e
            layout += '</ul>'
        })


        if (isMobile()) {
            $('.accordion-block .accordion').eq(accInd).find('table').remove();
            if ($('.accordion-block .accordion').eq(accInd).find('.table-container .mobile-branches').length < 1) {
                $('.accordion-block .accordion').eq(accInd).find('.table-container').append('<div class="mobile-branches">' + layout + '</div>');
            }
        }
        else {
            if ($('.accordion-block .accordion').eq(accInd).find('table').length < 1) {
                tableData.map((t, ind) => {
                    if (t.ti === accInd) {
                        $('.accordion-block .accordion').eq(accInd).find('.table-container').append(t.th);
                    }
                })
                $('.accordion-block .accordion').eq(accInd).find('.table-container .mobile-branches').remove();
            }
        }
    }





    var resourceTabs = $('.resource-tabs-block').html();

    function tabsRefactor() {
        var accLayout = '';
        $('.resource-tabs-block .product-tabs .tab').each(function () {
            var t = $(this);
            var ti = $(this).index();
            var tt = $(this).text();
            var tClasses = $(this).attr('class');

            accLayout += '<div class="accordion">'
            accLayout += '<label class="acc-title">' + tt + '</label>'

            $('.resource-tabs-block .tab-content .tab').each(function () {
                var tc = $(this);
                var tci = $(this).index();
                var tcData = $(this).html();
                var tcClasses = $(this).attr('class');
                if (tci === ti) {
                    accLayout += '<div class="acc-content">'
                    accLayout += tcData
                    accLayout += '</div>'
                    accLayout += '</div>'
                }
            })
        })

        if (isMobile()) {
            if ($('.resource-tabs-block .tabs-container').length < 1) {
                $('.resource-tabs-block').empty();
                $('.resource-tabs-block').append('<div class="tabs-container container">' + accLayout + '</div>');
                $('.tabs-container .acc-title').off();
                $('.tabs-container .acc-title').on('click', function () {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $(this).next().slideUp();
                    } else {
                        $(this).addClass('active');
                        $(this).next().slideDown();
                    }
                });
            }
        }
        else {
            if ($('.resource-tabs-block .product-tabs').length < 1) {
                $('.resource-tabs-block').append(resourceTabs);
                $('.resource-tabs-block .tabs-container').remove();

                $('.resource-tabs-block .product-tabs a').on('click', function (e) {
                    e.preventDefault();
                    $('.resource-tabs-block .product-tabs a').removeClass('active');
                    $(this).addClass('active');
                    var id = $(this).attr('data-id');
                    $(".tab-content .tab").removeClass('active');
                    $(".tab-content .tab[data-id=" + id + "]").addClass('active');
                });
            }



        }
    }

    tabsRefactor();

    function coreValues() {
        if (isMobile()) {
            $('.tabs-content-wrap .tab label').off();
            $('.tabs-content-wrap .tab label').on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).next().slideUp();
                } else {
                    $(this).addClass('active');
                    $(this).next().slideDown();
                }
            });
        }
        else {
            $('.tabs-content-wrap .tab label').off();
            $('.value-tab-content').css('display', '');
        }
    }



    $('#trade-accelerator-application-submit').click(function () {
        var st = $('.tabs-wrap').offset().top
        $('html').animate({
            scrollTop: st - 220
        })
        // setTimeout(getTabHeight, 200)
    })

    var tradeData = $('.trade-register .container').html();
    var tradeHeading = $('.trade-register .container .content-part h1').html();
    var tradeAccTitle = $('.trade-register .container .content-part p strong').html();
    var tradeContent = $('.trade-register .container .content-part').html();
    var traderhnClone = '<div class="rhn">' + $('.trade-register .container .rhn').html() + '</div>';

    function mobileAdjustments() {

        if ($(window).width() < 768) {
            var prodTitle = $('.showcase-data h1').height();
            var contH = $('.product-controls').height();
            var totalGap = (prodTitle + contH) + 44;
            $('.product-controls').css('top', (prodTitle + 19) + 'px');
            $('.showcase-images').css('margin-top', totalGap + 'px');
            if ($('.product-tiles-block .product-group .sort-wrap .filter-view-toggle').length < 1) {
                $('.product-tiles-block .product-group .sort-wrap').prepend('<a href="#" class="btn filter-view-toggle">Filters</a>');
                $('.product-listing-block:not(.event-listing-block) .sidebar-head label').after('<a href="#" class="close-filter"></a>');
            }
            if ($('.event-listing-block .product-tiles-block .filter-view-toggle').length < 1) {
                $('.product-tiles-block .events-filters').after('<a href="#" class="btn filter-view-toggle">Filters</a>');
                $('.event-listing-block .sidebar-head label').after('<a href="#" class="close-filter"></a>');
            }
            if ($('.joblist-tiles-block .account-links .sidebar-toggle').length < 1) {
                $('.joblist-tiles-block .account-links').prepend('<a href="#" class="sidebar-toggle"><img src="images/profile-icon-white.svg" /></a>');
            }

            if ($('.trade-register .container .application-terms').length < 1) {
                $('.trade-register .container').empty();
                $('.trade-register .container').prepend('<h1>' + tradeHeading + '</h1><label class="acc-title active">Application terms</label><div class="acc-content application-terms" style="display:block;">' + tradeContent + traderhnClone + '</div>');
                $('.trade-register .container .application-terms h1 + p, .trade-register .container .application-terms h1').remove();
            }

            if ($('.login-popup').length > 0) {
                $('.reset-screen .back-link').html('Log In');
            }

            mobileFilters();
        }
        else {
            $('.value-tab-content').css('display', '');
            $('.product-group .sort-wrap .filter-view-toggle, .event-listing-block .product-tiles-block .filter-view-toggle').remove();
            $('.sidebar-head .close-filter').remove();
            $('.trade-register .container').empty();
            $('.trade-register .container').prepend(tradeData);
            if ($('.login-popup').length > 0) {
                $('.reset-screen .back-link').html('Back');
            }
        }
    }

    mobileAdjustments();

    $(document).ajaxComplete(mobileAdjustments);

    $('.ev-form-block .attached-files').on("DOMSubtreeModified", function () {
        getTabHeight();
    });


    function locationCardInteraction() {
        $('.location-card').click(function () {
            $('.location-card').removeClass('active');
            $(this).addClass('active');
        })
    }

    locationCardInteraction();
    $(document).ajaxComplete(locationCardInteraction);


    const registerServiceWorker = async () => {
        if ("serviceWorker" in navigator) {
            try {
                const registration = await navigator.serviceWorker.register("/serviceworker.js", {
                    scope: "/",
                });
            } catch (error) {
                console.error(`Registration failed with ${error}`);
            }

            if (navigator.serviceWorker.controller) {
                console.log('SW installed')
            }

            navigator.serviceWorker.oncontrollerchange = (ev) => {
                console.log('SW activated')
            }
        }
    };


    // registerServiceWorker();

    function prodCodeSize() {
        var content = 'Middy’s Part Number (Product Code)';
        $('.prod-code').mouseover(function (e) {
            var size = Math.round($(this).outerWidth());
            var leftPos = ((size - 230) / 2) + 'px';
            $(this).attr('data-size', size + 'px');
            if (!$(this).parents().hasClass('cart-collection-block')) {
                $(this).append('<span class="prod-tooltip" style="left: ' + leftPos + '">' + content + '</span>')
            }
            else if ($(this).parents().hasClass('order-detail-block')) {
                $(this).append('<span class="prod-tooltip" style="left: ' + leftPos + '">' + content + '</span>')
            }

        })

        $('.prod-code').mouseout(function (e) {
            var t = e.target;
            if (!$(t).parent().is('.prod-code')) {
                $(this).find('.prod-tooltip').remove();
            }
        })

        tooltipFix();

    }

    $('.next-step').click(prodCodeSize);

    setTimeout(prodCodeSize, 300);

    $(document).ajaxComplete(prodCodeSize);

    function tooltipFix() {
        if ($('.products-slider').length > 0) {
            $('.products-slider').each(function () {
                var arr = []
                $(this).find('.owl-stage .owl-item').each(function () {
                    if ($(this).hasClass('active')) {
                        arr.push($(this).index());
                    }
                })
                $(this).find('.owl-stage .owl-item').eq(arr[0]).addClass('movetooltip');
                $(this).find('.owl-stage .owl-item:not(.active)').removeClass('movetooltip');
            })
        }
    }


    // RESIZE EXECUTIONS
    var dwidth = $(window).width();

    $(window).resize(function () {
        var wwidth = $(window).width();
        if (dwidth !== wwidth) {
            dwidth = $(window).width();
            formPlacement();
            homePromo();
            //menuPlacement();
            menuInteractions();
            screenSize = $(window).width();
            nonProductCarousel();
            productCarousel();
            winnersCarousel();
            packagesCarousel();
            evProductCarousel();
            brandsSlider();
            mediaSlider();
            mediaChange();
            //navPos();
            $('.cart-collection-block .tabs-wrap').height($('.cart-collection-block .tabs-wrap .tab.active').outerHeight());
            branchStateReposition();
            tabsRefactor();
            coreValues();
            mobileAdjustments();
            footerLinks();
            tableData.map((t, ind) => {
                tableRefactor(t.ti);
            });
        }
    });


    //MOBILE MENU
    var alertHeight, alertHead, adjustTop, winHeight, adjustHeight;

    if ($(window).width() <= 767) {
        alertHeight = $('.alert-bar').outerHeight();
        alertHead = $('.mobile-menu .header-top').outerHeight();
        adjustTop = alertHeight + alertHead;
        winHeight = $(window).height();
        adjustHeight = (winHeight - adjustTop) - 40;
        resizeMenu();
    }

    $('.alert-bar .close').click(function () {
        alertHeight = 0;
        adjustTop = alertHeight + alertHead;
        winHeight = $(window).height();
        adjustHeight = (winHeight - adjustTop) - 40;
        resizeMenu();
    })

    function resizeMenu() {
        $('.header-top + nav').css({
            height: adjustHeight,
            top: adjustTop
        })
    }
});

$(document).ready(function () {

    $('.main-accordion-heading').on('click', function (event) {
        var lsData = localStorage.getItem('accordionData')
        if (!$(event.target).is('.checkbox label') && !$(event.target).is('.checkbox input') && !$(event.target).is('.main-accordion-heading a')) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).next().slideUp();
            } else {
                $(this).addClass('active');
                $(this).next().slideDown();
            }
        }
    });
    $('.eft-btn').click(function (e) {
        e.preventDefault();
        $('.eft-payment').fadeIn();
    })
    $('.close-dialog').click(function (e) {
        e.preventDefault();
        $('.eft-payment').fadeOut();
        $(this).parents('.overlay').fadeOut();
    })

    $('input[type=checkbox] + label').click(function (e) {
        if ($(this).hasClass('partial')) {
            e.preventDefault();
            $(this).removeClass('partial');
        }
    })

    let paymentTop = $('.account-links.summary-block').clone()
    // console.log(paymentTop)

    function addPaymentButtons() {
        if ($(window).width() < 1025) {
            $('.payments-balance').after(paymentTop)
        }
        else {
            $('.balance-payment .product-group.address-group.invoices-group .account-links.summary-block').remove();
        }
    }

    addPaymentButtons();

    $(window).resize(addPaymentButtons);

    $('.invoice-list .main-accordion').each(function (e) {
        $(this).find('.main-accordion-heading').each(function (e) {
            var $this = $(this)
            let str = $this.find('.trade-row:not(.trade-heading) .col').eq(1).find('span')
            let months = str.html().split(' ')
            let trimmedText
            if (months[0] === 'September' || months[0] === 'september') {
                trimmedText = months[0].trim().substring(0, 4)
            }
            else {
                trimmedText = months[0].trim().substring(0, 3)
            }

            str.html(`${trimmedText} ${months[1]}`)
        })
    })




});

function addGoogleAnalyticsEvent(eventDetails) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventDetails);
}
